import React from "react";

/**
 * Render a compact metric card for a project overview summary section.
 *
 * @param {Object} props - Component props.
 * @param {string} props.value - Primary metric value.
 * @param {string} props.label - Secondary metric label.
 * @param {string} [props.accent] - Optional accent key (e.g. "overtime", "doubletime").
 * @returns {JSX.Element}
 */
const ProjectMetricCard = ({ value, label, accent }) => (
  <div className="rounded-lg border border-gray-200 bg-gray-50/80 px-4 py-3 shadow-sm">
    <div
      className={`text-2xl font-bold tracking-tight ${
        accent === "overtime"
          ? "text-amber-600"
          : accent === "doubletime"
            ? "text-yellow-600"
            : "text-gray-950"
      }`}
    >
      {value}
    </div>
    <div className="mt-1 text-xs font-medium uppercase tracking-wide text-gray-500">
      {label}
    </div>
  </div>
);

export default ProjectMetricCard;
